angular.module('picmonic-common')
    .factory("WebinarResource", ['$resource', function($resource){
        return $resource("/apiv2/webinars/:webinar_id/:resource_type", {webinar_id: '@webinar_id', resource_type: '@resource_type'});
    }]);